import React from 'react';
import styled from 'styled-components';
import Link from '@com/core/common/components/Link';

type TProps = {
    data: {
        titleText?: string;
        titleImageUrl?: string;
        linkText?: string;
        linkUrl?: string;
        linkBgColor?: string;
        titleColor?: string;
    };
    textColor?: string;
    className?: string;
};

type TModuleHeaderContainerProps = {
    linkTextColor?: string;
    linkBgColor?: string;
};

const ModuleHeaderContainer = styled.div<TModuleHeaderContainerProps>`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 14px;

    a {
        font-weight: bold;
        color: ${({ linkTextColor, theme: { colors } }): string => linkTextColor || colors.brandSecondary};
        font-size: 0.916666rem;
        text-transform: uppercase;
        letter-spacing: 0.2px;
        padding: 6px 12px;
        margin-left: 10px;
        border: 1px solid;
        background-color: ${({ linkBgColor, theme: { colors } }): string => linkBgColor || colors.bgPrimary};

        :global(html[dir='rtl']) & {
            margin-right: 10px;
            margin-left: 0;
        }
    }
`;

const Title = styled.h3`
    font-weight: bold;
    font-size: 1.5rem;
    flex: 1;
`;

const ImageContainer = styled.div`
    max-width: 190px;
`;

const Image = styled.img`
    display: block;
    max-width: 100%;
`;

const ModuleHeader = ({ className, data, textColor }: TProps): JSX.Element => {
    return (
        <ModuleHeaderContainer className={className} linkTextColor={textColor} linkBgColor={data.linkBgColor}>
            {data.titleText && <Title style={{ color: data.titleColor }}>{data.titleText}</Title>}
            {data.titleImageUrl && (
                <ImageContainer>
                    <Image src={data.titleImageUrl} alt="moduleHeader" />
                </ImageContainer>
            )}
            {data.linkText && <Link href={`/${data.linkUrl}`}>{data.linkText}</Link>}
        </ModuleHeaderContainer>
    );
};

export default ModuleHeader;
